// Third-party
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";

// Asset components
import AppLogo from "../../assets/ITC-Logo-1.svg";

// Components
import Logout from "../logout/Logout";

// Services
import { getStorageItemLocal } from "../../services/storageServices";

// Styles
import "./Header.scss";

const Header: React.FC = () => {
  // useState
  const [username, setUsername] = useState<string>("");
  const [role, setRole] = useState<string>("");

  // useEffect
  useEffect(() => {
    const storedUsername = getStorageItemLocal("username");
    const storedRole = getStorageItemLocal("role");

    if (storedUsername) setUsername(JSON.parse(storedUsername));
    if (storedRole) setRole(JSON.parse(storedRole));
  }, []);

  return (
    <div className="header">
      <Box className="itcmap-logo">
        <img src={AppLogo} alt="Logo" />
        <Box sx={{ paddingLeft: "10px", paddingTop: "5px" }}>
          <Typography className="header-title">World of ITC</Typography>
        </Box>
      </Box>

      <Box
        className="desktop-header"
        sx={{ display: { xs: "none", md: "flex" } }}
      >
        <Box
          sx={{
            paddingRight: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "center",
          }}
        >
          <Typography sx={{}} className="header-title">
            {username}
          </Typography>
          <Typography className="header-subtitle ">{role}</Typography>
        </Box>

        <Box className="icon-buttons">
          <div className="logout-container">
            <Logout />
          </div>
        </Box>
      </Box>
    </div>
  );
};

export default Header;
